// Module
var code = `<div class="alert">
  <span>
    <strong>DISCLAIMER:</strong> This form can be used to update cash & check asset counter values for each branch
  </span>
</div>
<div class="alert">
  This command does not reset the current asset value, given
  value will be added to current value. If you wish to decrease counter value provide
  negative value in cash/check field
</div>

<h2 class="section-header">Please confirm the following:</h2>
<form name="\$ctrl.form">
  <table class="table">
    <tbody>
    <tr>
      <td>Branch:</td>
      <td>
        <select
          ng-model="\$ctrl.commandInput.branchId"
          ng-options="branch.id as branch.name | prettyEnum for branch in \$ctrl.branches | orderBy:'name'"
          ng-change="\$ctrl.onBranchChange(\$ctrl.commandInput.branchId)"
          required>
        </select>
      </td>
    </tr>
    <tr>
      <td>Current cash:</td>
      <td>
        <cash value="\$ctrl.branchCash"
          ng-disabled="true"></cash>
      </td>
    </tr>
    <tr>
      <td>Increase cash by:</td>
      <td>
        <cash min="-10000000000"
          ng-model="\$ctrl.commandInput.cashDiff"
          ng-required="true"></cash>
      </td>
    </tr>
    <tr>
      <td>Current check:</td>
      <td>
        <cash value="\$ctrl.branchCheck"
          ng-disabled="true"></cash>
      </td>
    </tr>
    <tr>
      <td>Increase check by:</td>
      <td>
        <cash ng-required="true"
          min="-10000000000"
          ng-model="\$ctrl.commandInput.checkDiff"></cash>
      </td>
    </tr>
    </tbody>
  </table>

  <div class="pull-right">
    <button
      type="submit"
      class="btn btn-success"
      ng-disabled="\$ctrl.form.\$invalid"
      ng-click="\$ctrl.execute()">
      Execute
    </button>
  </div>
</form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/support/misc/update-branch-asset-counter/update-branch-asset-counter.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;